import { W as WuiFormField$1, d as defineCustomElement$1 } from './p-BlW2joRF.js';

const WuiFormField = WuiFormField$1;
const defineCustomElement = defineCustomElement$1;

export { WuiFormField, defineCustomElement };
